import { useRouter } from 'next/navigation'
import type { FC } from 'react'
import { Trans } from 'react-i18next'

import configuration from '~/configuration'
import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import { isHTML } from '~/core/utilities/common'

import { NOTE_TAB } from '~/lib/features/candidates/utilities/enum'
import type { INotification, INotificationProfile } from '~/lib/features/notifications/types'

import HTMLDisplay from '~/components/HTMLDisplay'

import NotificationItemLayout from './NotificationItemLayout'

const UserMentionProfileNote: FC<{
  notification: INotification
  onClick: () => void
  onDelete: () => void
  isLoadingDeleted: boolean
}> = ({ notification, onClick, onDelete, isLoadingDeleted }) => {
  const router = useRouter()
  const propertiesRelated = notification?.payload as INotificationProfile

  return (
    <NotificationItemLayout
      onDelete={onDelete}
      isLoadingDeleted={isLoadingDeleted}
      user={notification.user}
      actionType={notification.actionType}
      readAt={notification.readAt}
      createdAt={notification.createdAt}>
      {({ time }) => (
        <>
          <TypographyText
            className="cursor-pointer text-sm text-gray-700"
            onClick={() => {
              onClick && onClick()
              router.push(
                `${configuration.path.candidates.detail(
                  propertiesRelated.profileId
                )}?tabs=${NOTE_TAB}`
              )
            }}>
            <Trans
              i18nKey="activity:notification:userMentionProfileNote"
              values={{
                userName: notification?.user?.fullName,
                profileFullName: propertiesRelated?.profileFullName
              }}>
              <span className="font-medium text-gray-900" />
            </Trans>
            {time}
          </TypographyText>

          {propertiesRelated?.content ? (
            <div
              className={cn(
                'rounded-xs mt-1.5 border border-gray-100 bg-gray-50 px-1.5 pt-3',
                isHTML(propertiesRelated.content) ? 'pb-1.5' : 'pb-3'
              )}>
              <HTMLDisplay
                content={propertiesRelated.content}
                className="line-clamp-2 text-xs text-gray-900"
              />
            </div>
          ) : null}
        </>
      )}
    </NotificationItemLayout>
  )
}

export default UserMentionProfileNote
